module.exports = {"BASE":"//submit.proofreadingmanuscripts.com/","BASE1":"http://localhost:3001/","PAYPAL_ENV":"production","STRIPE_ENV":"live"}


//////////////////
// WEBPACK FOOTER
// ./src/config/config.json
// module id = 20
// module chunks = 0